export default __webpack_public_path__ + "static/media/Elisa 9781408312964.9fccaee2.jpg";